exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".form-error{color:#ff5f5f}", "", {"version":3,"sources":["/divvit-app/client/components/FormError/client/components/FormError/style.styl","/divvit-app/client/components/FormError/style.styl"],"names":[],"mappings":"AAAA,YACE,aAAA,CCCD","file":"style.styl","sourcesContent":[".form-error\n  color: brand-red\n",".form-error {\n  color: #ff5f5f;\n}\n/*# sourceMappingURL=client/components/FormError/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/components/FormError/style.styl
// module id = 530
// module chunks = 0